import axios from './axios';

export const getTodayRoutes = () => axios.get('/transportation/routes/overview');

export const createNewRouteStation = (station, routeId, direction) =>
  axios.post(`/transportation/routes/${routeId}/stations/${direction}`, station);

/**
 * @api delete /transportation/routes Remove route
 * @param { string } routeId - routeId for removing
 * @return { Promise }
 * */
export const deleteRoute = routeId => axios.delete(`/transportation/routes/${routeId}`);

export const deleteRouteStation = (routeId, stationId, direction) =>
  axios.delete(`/transportation/routes/${routeId}/stations/${direction}/${stationId}`);

export const getActiveRouteDetails = routeId =>
  axios.get(`/transportation/routes/active/${routeId}`);

export const terminateActiveRoute = (routeId, completed = false) =>
  axios.put(`/transportation/routes/active/${routeId}?completed=${completed}`);

export const getInactiveRouteDetails = routeId =>
  axios.get(`/transportation/routes/inactive/${routeId}`);

export const getActiveRouteDetailsInfo = routeId =>
  axios.get(`/transportation/routes/active/${routeId}/info`);

export const getActiveRoutesHistory = query =>
  axios.post('/transportation/routes/active/history/search', query);

export const getActiveRouteStationsStatistic = routeId =>
  axios.get(`/transportation/routes/active/history/${routeId}/stations/statistic`);

export const getActiveRouteStudentsStatistic = routeId =>
  axios.get(`/transportation/routes/active/history/${routeId}/students/statistic`);

export const getDetailedActiveRouteHistory = routeId =>
  axios.get(`/transportation/routes/active/history/${routeId}/details`);

export const getRouteCarriersRelations = routeId =>
  axios.get(`/transportation/routes/${routeId}/companies/relations`);

export const updateRouteRelations = (routeId, busesAndDrivers) =>
  axios.post(`/transportation/routes/${routeId}/companies/relations`, busesAndDrivers);

export const getBusRoutes = busId => axios.get(`/transportation/routes/buses/${busId}`);

export const getDriverRoutes = driverId => axios.get(`/transportation/routes/drivers/${driverId}`);

export const removeStationsByDirection = (routeId, direction) =>
  axios.delete(`/transportation/routes/${routeId}/stations/${direction}`);

export const searchActiveRouteDelaysHistory = (routeId = '', query = {}) =>
  axios.post(`/transportation/routes/active/history/${routeId}/delays`, query);

export const searchActiveRouteLocationsHistory = (routeId = '', query = {}) =>
  axios.post(
    `/transportation/routes/active/history/${routeId}/location/requests?showDriver=true`,
    query,
  );

export const activeRouteLocationHistory = (routeId = '', query = {}) =>
  axios.post(
    `/transportation/routes/active/history/${routeId}/location/requests?showDriver=true`,
    query,
  );

export const searchActiveRouteStationsHistory = (routeId = '', query = {}) =>
  axios.post(`/transportation/routes/active/history/${routeId}/stations`, query);

export const searchActiveRouteStudentsHistory = (routeId = '', query = {}) =>
  axios.post(`/transportation/routes/active/history/${routeId}/students`, query);

/**
 * @api post /transportation/routes Create route
 * @param { object } query - query for searching
 * @return { Promise }
 * */
export const searchRoutes = query => axios.post('/transportation/routes/search', query);

/**
 * @api post /transportation/routes Create route
 * @return { Promise }
 * @param routeId
 * */
export const getRouteById = routeId => axios.get(`/transportation/routes/${routeId}`);

/**
 * @api post /transportation/routes Create route
 * @param { object } route - new route
 * @return { Promise }
 * */
export const createNewRoute = route => axios.post('/transportation/routes', route);

/**
 * @api post /transportation/routes Edit route
 * @param { object } route - edited route
 * @return { Promise }
 * */
export const editRoute = route => {
  const { id, ...routeData } = route;

  return axios.put(`/transportation/routes/${id}`, routeData);
};

export const reflectStations = (routeId, direction) =>
  axios.put(`/transportation/routes/${routeId}/stations/${direction}/reflect`);

export const setCommonRouteSchedule = (routeId, direction) =>
  axios.put(`/transportation/routes/${routeId}/${direction}/schedule/common`);

export const updateStation = (routeId, stationId, direction, station) =>
  axios.put(`/transportation/routes/${routeId}/stations/${direction}/${stationId}`, station);

export const updateStationsSchedule = (routeId, direction, schedule) =>
  axios.put(`/transportation/routes/${routeId}/stations/${direction}/schedule`, schedule);

export const updateStationOrder = (routeId, stationId, direction, operation) =>
  axios.put(`/transportation/routes/${routeId}/stations/${direction}/${stationId}/order`, {
    operation,
  });

export const copyRoute = (routeId, name, number, campusId) =>
  axios.post(`transportation/routes/${routeId}/copy`, {
    name,
    number,
    campusId,
  });

export const getLogHistoryData = (routeId, query) =>
  axios.post(`/transportation/routes/active/history/${routeId}/students`, query);

export const getRouteStopHistoryData = (routeId, query) =>
  axios.post(`/transportation/routes/active/history/${routeId}/stations`, query);
